import React from 'react';
import Menu from '../menu';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
	wrapper: {
		margin: '0 auto',
		maxWidth: '960px',
		padding: '0px 20px 40px 20px',
	},
}));

const Index = ({ children }) => {
	const classes = useStyles();
	return (
		<div>
			<Menu />
			<div className={classes.wrapper}>{children}</div>
		</div>
	);
};

export default Index;
